import React from 'react';

import classNames from 'classnames';

import classes from './PriceInfo.module.scss';
import { getPriceView } from '../../../shared/utils/stringUtils';
import { getIsNullish } from '../../../shared/utils/jsUtils';

type PriceInfoProps = {
  price?: number | null;
  finalPrice?: number | null;
  duration?: string;
  hidePrice?: boolean;
  hiddenPricePlaceholder?: string;
};

const PriceInfo = ({
  price,
  finalPrice,
  duration,
  hidePrice,
  hiddenPricePlaceholder = '—',
}: PriceInfoProps) => {
  const pricesContainerClasses = classNames(classes.pricesContainer, 'private-info');

  if (getIsNullish(finalPrice) || hidePrice) {
    // class need do add same font
    return <div className={pricesContainerClasses}>{hiddenPricePlaceholder}</div>;
  }

  const isDiscountUsed = price !== finalPrice;

  return (
    <div className={pricesContainerClasses}>
      {isDiscountUsed && <p className={classes.oldPrice}>{getPriceView(price)}</p>}
      <p className={classes.priceBox}>
        <span>{getPriceView(finalPrice)}</span>
        {duration && (
          <>
            <span>/</span>
            <span className={classes.description}>{duration}</span>
          </>
        )}
      </p>
    </div>
  );
};

export { PriceInfo, type PriceInfoProps };
